// eslint-disable-next-line no-shadow
enum EUserType {
    Employee = 2,
    Business = 4,
    Admin = 5,
}

export default EUserType
